import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {WinConfig, WinConfigUtil} from "../../../utils/WinConfigUtil";
import {TheCage} from "../../../TheCage";
import {TheCageSymbol, TheCageSymbolStates} from "../../../reels/TheCageSymbol";
import {SymbolUtils} from "../../../utils/SymbolUtils";
import {TheCageStatics} from "../../../config/TheCageStatics";
import {GSAPUtils} from "../../../utils/GSAPUtils";
import {StateMatrixCoordinate} from "../../../utils/StateMatrix";
import {BetWayWin} from "../../../server/TheCageData";
import {TheCageGameMode} from "../../../server/TheCageGameMode";
import {SimpleReelModelSymbolData} from "../../../../core/reel/simplereel/SimpleReelModel";
import {TheCageSound} from "../../../sound/TheCageSound";


/**
 * Created by jonas on 2022-01-12.
 */

export class NormalWin implements SimplePresentation {

    name:string = "NormalWin";
    //protected skipped:boolean;
    //// second variable needing when skipping to avoid a race condition
    //// the race condition is us skipping between the two "controller.finish" lambdas
    //protected done:boolean;

    // NOTE: was used before the callbackFinishedHack but due to the member being shared across all calls to
    // the NormalWin presentation the second callback (that is the one outside getInitialWin) would sometimes fire due
    // to the next spin resetting this variable, the solution was to simple use a new object for every call to
    // NormalWin, very very hacky but it solves the problem
    //protected finished:boolean;

    constructor() {
        //this.skipped = false;
        //this.done = false;
    }

    //protected wasSkipped():boolean {
    //   return this.skipped;
    //}

    //protected setupSkipVariables() {
    //    this.skipped = false;
    //    this.done = false;
    //}

    private getAllConfigsForLevel(levelName:string, winConfigs:WinConfig[]) {
        const result = [];
        for (let conf of winConfigs) {
            if (conf.name == levelName) {
                result.push(conf);
            }
        }
        return result;
    }

    start(controller:SimplePresentationRunnerController):void {
        //this.setupSkipVariables();
        const callbackFinishedFixHack = {finished:false};

        const tl:gsap.core.Timeline = gsap.timeline()//{onComplete:() => controller.finish()});
        const isBigWin = TheCage.model.winData.winRatio >= 15;
        //const isBigWin = Octagon.model.winRatio >= 18; //This, takes the 20% rule into account. So it wont try to do bigwin, if it's not at least 20% over the limit.

        const belowStakeWinRestriction = TheCage.isWinBelowStake();


        const multiplier = 1;
        let winConfigs:WinConfig[] = [];
        for (let i:number = 1; i <= multiplier; i++) {
            const startRatio = TheCage.model.winData.winRatio * (i - 1);
            const endRatio = TheCage.model.winData.winRatio * i;

            if (isBigWin) {
                winConfigs = winConfigs.concat(WinConfigUtil.getBigWinLevels(startRatio, endRatio, i, i == multiplier));
            } else {
                winConfigs = winConfigs.concat(WinConfigUtil.getNormalWinLevels(startRatio, endRatio, i, i == multiplier));
            }
        }


        const lastLevelName = winConfigs[winConfigs.length - 1].name;
        if (isBigWin) {
            //This makes sure that the last bigwin level is played in full duration but only to the win amount. With the multipliers spaced out based on the multiplier ratio.
            let lastLevelConfigs = this.getAllConfigsForLevel(lastLevelName, winConfigs);
            for (let config of lastLevelConfigs) {
                config.durationRatio = config.calculateDurationNew(lastLevelConfigs[0].fromRatio, lastLevelConfigs[lastLevelConfigs.length - 1].toRatio);
            }
        }

        // a hack to play custom sounds in freespin
        this.playWinSound(winConfigs, belowStakeWinRestriction, tl);
        tl.add(this.getInitialWin(isBigWin && !TheCage.model.winCapReached, lastLevelName, controller, callbackFinishedFixHack));
        tl.add(() => {
            if (!callbackFinishedFixHack.finished) {
                callbackFinishedFixHack.finished = true;
                controller.setSkipCallback();
                controller.finish();
            }
        });


        // moved into getInitialWin to stop race condition, kind of a hack but its needed to stop the game from crashing
        // if the player clicks too fast
        //tl.addLabel("ending");
        //tl.add(() => {
        //    controller.setSkipCallback();
        //    controller.finish();
        //});
        //tl.add(() => {
        //    if (this.wasSkipped()) {
        //        this.done = true;
        //        controller.setSkipCallback();
        //        controller.finish();
        //    }
        //}, tl.duration() / 2 + 0.04);
    }

    // a hack to play custom sounds in freespin
    protected playWinSound(winConfigs:WinConfig[], belowStakeWinRestriction:boolean, tl:gsap.core.Timeline) {
        const lastLevelConfig:WinConfig = winConfigs[winConfigs.length - 1].clone();
        if (lastLevelConfig.sound?.init && !belowStakeWinRestriction && TheCage.model.winData.lines.length > 0) {
            const soundName = lastLevelConfig.sound?.init!;
            tl.add(() => TheCage.soundPlayer.playSound(soundName));
        }
    }

    protected getInitialWin(isBigWin:boolean, lastLevelName:string, controller:SimplePresentationRunnerController, callbackFixHack:{finished:boolean}):gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline({onComplete: () => {
                console.log(`BRUH end ${tl.totalProgress() * tl.duration()} / ${tl.duration()}`)
                if (!callbackFixHack.finished) {
                    callbackFixHack.finished = true;
                    controller.finish();
                    controller.setSkipCallback();
                }
            }});
        tl.add(() => controller.setSkipCallback(() => {
            console.log(`BRUH clicked ${tl.totalProgress() * tl.duration()} / ${tl.duration()}, global: ${tl.globalTime()}`)
            tl.timeScale(2);
            TheCage.soundPlayer.stopSound(TheCageSound.WIN_SWEEP_TINY);
            TheCage.soundPlayer.stopSound(TheCageSound.WIN_SWEEP_SMALL);
            TheCage.soundPlayer.stopSound(TheCageSound.WIN_SWEEP_MEDIUM);
            TheCage.soundPlayer.stopSound(TheCageSound.WIN_SWEEP_LARGE);
            TheCage.soundPlayer.stopSound(TheCageSound.WIN_BOTHWAYS_SWEEP);
        }));
        tl.add(() => {
            console.log(`BRUH start ${tl.totalProgress() * tl.duration()} / ${tl.duration()}`)
        })

        let winSymbols, noWinSymbols;
        if (TheCage.model.data.mode == TheCageGameMode.FREESPIN || TheCage.model.data.mode == TheCageGameMode.FREESPIN_AVALANCHE) {
            winSymbols = SymbolUtils.getAllFreespinSymbolsWithStateByReel(TheCageSymbolStates.WIN_TINY);
            noWinSymbols = SymbolUtils.getAllFreespinSymbolsWithState(TheCageSymbolStates.NO_WIN);
        } else {
            winSymbols = SymbolUtils.getAllSymbolsWithStateByReel(TheCageSymbolStates.WIN_TINY);
            noWinSymbols = SymbolUtils.getAllSymbolsWithState(TheCageSymbolStates.NO_WIN);
        }

        let winState = TheCageSymbolStates.WIN_TINY;
        if (lastLevelName == "SMALL") {
            winState = TheCageSymbolStates.WIN_SMALL;
        } else if (lastLevelName == "MEDIUM") {
            winState = TheCageSymbolStates.WIN_MEDIUM;
        } else if (lastLevelName == "LARGE") {
            winState = TheCageSymbolStates.WIN_LARGE;
        }

        if (isBigWin) {
            winState = TheCageSymbolStates.WIN_LARGE;
        }


        const multiplierCollect: gsap.core.Timeline[] = [];
        const winSymbolsTl = gsap.timeline();
        for (let reel of winSymbols) {
            const result: gsap.core.Timeline[] = [];

            //Reverse to add the symbols bottom to top.
            for (let sym of reel.reverse()) {
                sym.removed = true;
                const tl = (<TheCageSymbol>sym.positionable).getStateAnimation(winState);
                result.push(tl);
            }
            winSymbolsTl.add(result, `<${TheCageStatics.WIN_SYMBOL_DELAY}`);
        }

        tl.add(winSymbolsTl);




        const winLineAmountData:{betWin:BetWayWin, reelPos:StateMatrixCoordinate}[] = this.getWinWayAmountData();
        if (winLineAmountData.length > 0){
            tl.add(()=>{TheCage.winView.playLineWinDisplays(winLineAmountData)}, ">-0.6");
        }

        tl.add(SymbolUtils.getSymbolStateAnimations(noWinSymbols, TheCageSymbolStates.NORMAL),"<0.2");
        tl.add(GSAPUtils.createTimelineFromArray(multiplierCollect, "<0.1"),"<0.2");


        if (winSymbols[0].length > 0){
            tl.add(SymbolUtils.getSymbolStateAnimations(noWinSymbols, TheCageSymbolStates.NO_WIN), 0);
        }

        return tl;
    }

    protected getWinWayAmountData(){
        const winWayAmountData:{betWin:BetWayWin, reelPos:StateMatrixCoordinate, leftToRight:boolean, positions:StateMatrixCoordinate[]}[] = [];
        const fullLines:string[] = [];

        for (let i:number = 0; i < TheCage.model.winData.lines.length; i++) {
            const line = TheCage.model.winData.lines[i];
            const winPositions:StateMatrixCoordinate[] = line.matrix.getAllCoordinatesForValue(true);
            let lastPos:StateMatrixCoordinate;
            if (line.coordinates[0].column == 0 && !fullLines.some((sym) => sym == line.betWayWin.symbol)) {
                lastPos = <StateMatrixCoordinate>winPositions.pop();
            } else {
                lastPos = <StateMatrixCoordinate>winPositions.shift();
            }

            if (line.betWayWin.length == 9) {
                fullLines.push(line.betWayWin.symbol);
            }

            winWayAmountData.push({
                betWin:line.betWayWin,
                reelPos:lastPos,
                leftToRight:line.leftToRight,
                positions:line.coordinates,
            });
        }
        return winWayAmountData;
    }


    shouldRun():boolean {
        return !TheCage.model.gameData.brokeTheBank;
    }
}